import React from 'react';
import { Helmet } from 'react-helmet-async';
import AgeBracketCard from '../../components/health/AgeBracketCard';
import ageBrackets from '../../data/health/ageBrackets';

const HealthByAge = () => {
  return (
    <>
      <Helmet>
        <title>Health by Age | Health</title>
        <meta name="description" content="Nutrition, fitness, and lifestyle priorities broken down by age bracket — from infancy to 60+." />
        <meta property="og:title" content="Health by Age" />
        <meta property="og:description" content="What matters most for your health at every stage of life, from 0–3 to 60+." />
      </Helmet>

      <div className="health-page">
        <h1 className="health-page-title">Health by Age</h1>
        <p className="text-gray-300" style={{ maxWidth: 640, marginBottom: '2rem' }}>
          What matters most changes with age. Each bracket below covers nutrition, movement, sleep,
          common mistakes, and how this stage sets up the next — because health compounds.
        </p>

        <div className="health-cards-grid">
          {ageBrackets.map((bracket, i) => (
            <AgeBracketCard key={bracket.slug} bracket={bracket} index={i} />
          ))}
        </div>
      </div>
    </>
  );
};

export default HealthByAge;
